import UpdatePressItem from "./UpdatePressItem";
export default UpdatePressItem;
